export default "__VITE_ASSET__Q9N74qIA__"